import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import AppRoutes from './Routes';
import './App.css';

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Header />
      <div className="App">
        <AppRoutes />
      </div>
      <Footer />
    </BrowserRouter>
  );
};

export default App;
